export default __webpack_public_path__ + "static/media/1_tutorial_informed_search.d427d970.png";